export const NATIVE_TEST = {
    Web: 'Web',
    VoipPulseToPulse: 'VoipPulse',
    VoipPulseToPhone: 'VoipPhone',
    VoipDial: 'VoipDial',
    THRESHOLD_SENSATIVITY_DEFAULT: 4,
};

// IMPORTANT - These must match the 'group' field on TestType docs in the DB
export const NATIVE_TEST_TYPE_GROUPS = {
    WEB: 'Web',
    VOIP: 'VoIP',
};

const builtInTestMetricNames = {
    response_time: 'Average Response Time',
    namelookup_time: 'DNS',
    network_delay: 'Network',
    ssl_delay: 'SSL',
    client_delay: 'Client',
    app_delay: 'App',
    server_delay: 'Server',
    lqmos_avg: 'Caller',
    tx_lqmos_avg: 'Callee',
};

export function getMetricNameForBuiltInTest(rawMetricName) {
    return builtInTestMetricNames[rawMetricName] || rawMetricName;
}
